import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Dosis', sans-serif;
  }

  /* garante que sliders possam receber eventos de ponteiro */
  input[type="range"] {
    pointer-events: auto;
    cursor: pointer;
    -webkit-appearance: none;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
`

export const Background = styled.div`
  height: 100vh;
  /* corrigido: sintaxe correta do blur */
  filter: blur(0);
  background: linear-gradient(90deg, #faf0cd, #fab397);
  background-size: cover;
  overflow-x: hidden;
  opacity: 0.9;
`

export const BodySection = styled.section`
  height: 60%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
`

export const AddLeft = styled.section`
  height: 100%;
  width: 20%;
  color: palevioletred;
  pointer-events: auto;
`

export const SectionMid = styled.section`
  color: palevioletred;
  width: 60%;
`

export const AddRight = styled.section`
  height: 100%;
  color: palevioletred;
  width: 20%;
`

export const HeaderSection = styled.section`
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 60px;
  position: relative; /* permite z-index */
  z-index: 1000; /* garante que o header fique acima de possíveis iframes/ads */
  pointer-events: auto;
`

export const AddBelow = styled.section`
  height: 20%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: palevioletred;
`
export const Title = styled.h1`
  font-size: 10em;
  font-family: 'Dosis';
`
export const KeyboardImage = styled.img`
  height: 100%;
  width: 100%;
`

